import { render, staticRenderFns } from "./PosLoginView.vue?vue&type=template&id=0c65c11a&scoped=true"
import script from "./PosLoginView.vue?vue&type=script&lang=js"
export * from "./PosLoginView.vue?vue&type=script&lang=js"
import style0 from "./PosLoginView.vue?vue&type=style&index=0&id=0c65c11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65c11a",
  null
  
)

export default component.exports